<template>
  <v-dialog :value="dlg" max-width="300px" persistent style="margin: auto 4px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title || 'Are you sure?' }}</span>
      </v-card-title>
      <v-card-text>
        {{ text }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn flat @click="confirmed(false)">{{ noLabel || 'Cancel' }}</v-btn>
        <v-btn :class="yesColorClass" flat @click="confirmed(true)">{{ yesLabel || 'Confirm' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ['title', 'text', 'yesLabel', 'noLabel', 'yesColor', 'dlg'],
    data: () => ({ }),
    computed: {
      yesColorClass() {
        return (this.yesColor || 'primary') + '--text'
      }
    },
    methods: {
      confirmed(val) {
        this.$emit('confirmed', val)
      }
    }
  }
</script>

<style scoped>
</style>
